<template>
  <div class="box-view">
    <Navbar />
    <div class="view">
      <b-container style="background-color:white; padding:2%" class="text-left">
        <b-row>
          <b-col lg="12" md="12" cols="12">
            <b-row>
              <b-col>
                <h3>ข้อมูลโครงการ</h3>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">รหัสโครงการ</b-col>
              <b-col>
                <b-form-input v-model="form.project_no" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ชื่อโครงการ</b-col>
              <b-col>
                <b-form-textarea v-model="form.project_name" rows="5" disabled></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ประเภทงาน</b-col>
              <b-col>
                <b-form-input id="typeJob" v-model="form.job_type_name" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">จังหวัด</b-col>
              <b-col>
                <b-form-input v-model="form.province_name" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ราคากลาง</b-col>
              <b-col>
                <b-form-input v-model="form.standard_price" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ราคาประมูล</b-col>
              <b-col>
                <b-form-input v-model="form.auction_price" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ส่วนลด</b-col>
              <b-col>
                <b-form-input v-model="form.discount" disabled></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12" md="12" cols="12">
            <b-row class="mt-5">
              <b-col>
                <h3>ข้อมูลบริษัท</h3>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">รหัสผู้เสียภาษี</b-col>
              <b-col>
                <b-form-input v-model="form.ebidding_customer_tax" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ชื่อ</b-col>
              <b-col>
                <b-form-textarea rows="3" v-model="form.cust_name" disabled></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">เบอร์โทรติดต่อ</b-col>
              <b-col>
                <b-form-input id="telCust" v-model="form.cust_tel" disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ที่อยู่</b-col>
              <b-col>
                <b-form-textarea rows="4" v-model="form.address" disabled></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">รายละเอียด</b-col>
              <b-col>
                <b-form-textarea rows="4" v-model="form.description" disabled></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">รายชื่อกรรมการ</b-col>
              <b-col>
                <b-form-textarea rows="4" v-model="committee" disabled></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="4" md="2">ผู้ดูเเล</b-col>
              <b-col>
                <b-form-input id="crmCust" v-model="form.crm_sale_fullname" disabled></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
export default {
  components: { Navbar, Footer },
  data() {
    return {
      form: {
        address: null,
        auction_price: null,
        cust_name: null,
        cust_tel: null,
        description: null,
        discount: null,
        ebidding_customer_tax: null,
        job_type_name: null,
        project_name: null,
        project_no: null,
        standard_price: null,
        province_name: null,
        crm_sale_fullname: null
      },
      committee: ""
    };
  },
  mounted() {
    axios
      .post("https://www.kmppartners.info:1030/api/view-data", {
        project_no: window.location.search.split("=")[1]
      })
      .then(res => {
        this.form = res.data.response[0];
        if(this.form.cust_tel === 'รอการระบุ'){
        document.getElementById('telCust').style.color = 'red'
      }
      if(this.form.crm_sale_fullname === 'รอการระบุ'){
        document.getElementById('crmCust').style.color = 'red'
      }
      if(this.form.job_type_name === 'รอการระบุ'){
        document.getElementById('typeJob').style.color = 'red'
      }
      });
    axios
      .post("https://www.kmppartners.info:1030/api/view-data/committee", {
        project_no: window.location.hash.split("=")[1]
      })
      .then(res => {
        for (let index = 0; index < res.data.response.length; index++) {
          this.committee += res.data.response[index].committee_name + "\n";
        }
      });
      
      
  }
};
</script>

<style>
.box-view {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.view {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 10%;
}
@media (max-width: 600px) {
  .view {
    padding-bottom: 30% !important;
  }
}
@media (max-width: 1024px) {
  .view {
    margin-bottom: 20% !important;
  }
}
</style>
